// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3EGo7","resendInfoText":"OnGoingPaymentBox_resendInfoText__27ZqG"};